import styled from 'styled-components';

import { $AccordionContainer } from '../Accordion.styles';

export const $Accordion = styled($AccordionContainer)`
  & > * {
    height: auto;
  }
`;
